import { useState, FC } from "react";
import { LogOut, User as UserIcon, CreditCard, Folder } from "lucide-react";
import { useAuthContext } from "./AuthProvider";

const AuthButton: FC = () => {
  const { user, signOut } = useAuthContext();
  const [showMenu, setShowMenu] = useState(false);

  const appUrl = process.env.REACT_APP_WEBAPP_URL;

  return (
    <div className="relative">
      <button onClick={() => setShowMenu((current) => !current)} className="btn btn-circle btn-sm">
        <UserIcon className="size-4" />
      </button>

      {showMenu && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setShowMenu(false)} />
          <div className="absolute right-0 top-full z-20 mt-2 w-56 bg-base-100 border border-base-300 rounded-lg shadow-lg">
            <div className="p-3 border-b border-base-300">
              <p className="text-sm font-medium truncate">{user.email}</p>
            </div>

            <div className="p-2 space-y-1">
              <a
                href={`${appUrl}/drive`}
                onClick={() => setShowMenu(false)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-ghost btn-sm w-full justify-start gap-2"
              >
                <Folder className="size-4" />
                <span>Mes documents</span>
              </a>

              <a
                href={`${appUrl}/subscription`}
                onClick={() => setShowMenu(false)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-ghost btn-sm w-full justify-start gap-2"
              >
                <CreditCard className="size-4" />
                <span>Abonnement</span>
              </a>

              <a
                href={`${appUrl}/profile`}
                onClick={() => setShowMenu(false)}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-ghost btn-sm w-full justify-start gap-2"
              >
                <UserIcon className="size-4" />
                <span>Profil</span>
              </a>

              <div className="pt-1">
                <button
                  onClick={() => {
                    setShowMenu(false);
                    signOut();
                  }}
                  className="btn btn-error btn-sm w-full gap-2"
                >
                  <LogOut className="size-4" />
                  <span>Se déconnecter</span>
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AuthButton;
